export default __webpack_public_path__ + "0db68a552e0083af3fa9ab60e20f2c5e.webp";